import { Alert, Box, Unstable_Grid2 as Grid } from '@mui/material';
import React from 'react';

import { InfoIcon, Select, ToggleButtonGroupField, Typography } from '@occc-app/design-system';
import { LocationMultipleSelectField } from '@occc-app/routes/Location/components/LocationSelect/LocationMultipleSelectField';
import { Store_Location_Evaluation_Method } from '@occc/graphql';

import { LocationGroupMultipleSelect } from './location-group-multiple-select';

import {
  StoreLocationOrGroupsFormValuesPaths,
  StoreLocationOrGroupsType,
} from '../store-location-or-groups.types';
import { locationOrGroupsTypeOptions } from '../store-location-or-groups.constants';
import { evaluationMethodOptions } from '../constants';

type StoreLocationOrGroupsConstraintProps = {
  type: StoreLocationOrGroupsType;
};

export const StoreLocationOrGroupsConstraint = ({ type }: StoreLocationOrGroupsConstraintProps) => {
  const isStoreLocationGroups = type === 'storeLocationGroups';
  const isStoreLocation = type === 'storeLocation';
  return (
    <Box>
      <Typography variant='h6' paragraph>
        Store Location or Groups
      </Typography>

      <Grid container spacing={3}>
        <Grid md={3} sm={6} xs={12}>
          <Select
            name={'storeLocationOrGroups.type' satisfies StoreLocationOrGroupsFormValuesPaths}
            label='Location or Groups'
            data={locationOrGroupsTypeOptions}
            formControlProps={{ size: 'medium' }}
          />
        </Grid>
        <Grid md={3} sm={6} xs={12}>
          <ToggleButtonGroupField
            name={
              'storeLocationOrGroups.storeLocation.evaluationMethod' satisfies StoreLocationOrGroupsFormValuesPaths
            }
            buttons={evaluationMethodOptions}
            disabled={isStoreLocationGroups}
            format={(value: string) =>
              isStoreLocationGroups ? Store_Location_Evaluation_Method.Include : value
            }
          />
        </Grid>
        {isStoreLocationGroups && (
          <Grid xs='auto'>
            <Alert icon={<InfoIcon />} severity='info' sx={{ alignItems: 'center' }}>
              <Typography variant='body2'>You can only include Store Location Groups</Typography>
            </Alert>
          </Grid>
        )}

        <Grid xs={12}>
          {isStoreLocation && (
            <LocationMultipleSelectField
              inputProps={{
                margin: 'none',
              }}
              name={
                'storeLocationOrGroups.storeLocation.locations' satisfies StoreLocationOrGroupsFormValuesPaths
              }
              label='Store Location Constraint'
            />
          )}

          {isStoreLocationGroups && (
            <LocationGroupMultipleSelect
              inputProps={{
                margin: 'none',
              }}
              name={
                'storeLocationOrGroups.storeLocationGroup.locationGroups' satisfies StoreLocationOrGroupsFormValuesPaths
              }
              label='Store Location Groups Constraint'
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
